import { observer } from "mobx-react-lite";
import AppConfig from "core/app-config";
import { SearchResultItem } from "core/models/search-result-item";
import SearchStore, { DisplayMode } from "core/stores/search.store";
import { getTabs } from "./display-mode-tab";
import SearchResult from "./search-result";

type SearchResultProps = {
  store: SearchStore;
  searchResults: SearchResultItem[];
  loadMore: () => void;
}

//TODO: The text should be configurable / i18n
const getSearchTitle = (store: SearchStore) => {
  const { totalCount, city } = store;
  const result = totalCount == 1 ? "result" : "results";
  return `${totalCount} ${result} for ${city}`;
}

const SearchResults = observer<SearchResultProps>((props) => {
  const { store, searchResults, loadMore } = props;

  const isMode = (mode: DisplayMode) => store.displayMode == mode

  const tabs = getTabs(store);

  const totalResults = isMode(DisplayMode.All)
    ? store.totalCount
    : isMode(DisplayMode.Dealers)
      ? store.dealers.length
      : store.installers.length;

  const showLoadMore = totalResults > 0
    && (store.numberOfResultsToShow < totalResults)
    && searchResults.length <= store.numberOfResultsToShow;

  const title = getSearchTitle(store);

  return <ul className="search-results">
    <li>
      <h6>{title}</h6>
      <ul>
        {tabs.map((tab, ix) => <li
          key={`tab-${ix}`}
          {...tab.analytics}
          onClick={() => store.updateDisplayMode(tab.mode)}
          className={isMode(tab.mode) ? "active" : ""}>
          {tab.tabText}
        </li>)}
      </ul>

    </li>
    {searchResults &&
      searchResults.map((x, ix) => <SearchResult item={x} key={`installer-${ix}`} />)}

    {showLoadMore && <li className="load-more" onClick={loadMore}>
      <i className="icon-load-more" />
      <p>
        {AppConfig.loadMore}
      </p>
    </li>}
  </ul>
});

export default SearchResults;
